<script setup lang="ts">
import { onMounted } from 'vue';
import Icon from '../icon/icon.vue';
import { useOrderTypeStore } from './stores/orderTypeStore';

const orderTypeStore = useOrderTypeStore();

// Loading view replaces the (possibly scrolled-down) cart/checkout view, so snap back to the top.
onMounted(() => window.scrollTo({ top: 0, behavior: 'instant' }));
</script>

<template>
  <div class="layout-new-checkout--loading">
    <div class="layout-new-checkout__loader">
      <h2>{{ orderTypeStore.isClickAndCollect ? $t('placingOrderClickAndCollect') : $t('placingOrderOnline') }}</h2>
      <Icon type="spinner" size="small" class="icon--spinner mr-2"></Icon>
    </div>
  </div>
</template>
